/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const subscriptionInfoResponseSchema = z
	.object({
		category: z.string().nullish(),
		expires_at: z.iso.datetime().nullish(),
		days_left: z.int().nullish(),
		saved_amount: z.string().regex(/^-?\d{0,10}(?:\.\d{0,2})?$/),
		orders_with_discount: z.int(),
	})
	.describe("Ответ эндпоинта /api/user/subscription.");
